import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

function usePortfolio() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb);

  return { data, isSuccess, refetch };
}

export default usePortfolio;
